import { drawerDisplayCondition } from '@wetransfer/transfer/component/TransferWindow/TransferWindow';
import { AppConfig } from '@wetransfer/transfer/core-bundle/config/app-config';
import Helper from '@wetransfer/transfer/helper';
import Cookie from '@wetransfer/transfer/modules/concorde-cookie';

const teamsDrawerDismissedForever = () =>
  Cookie.get(AppConfig.cookies.dismissTeamsDrawerForever.name);

const teamsDrawerBeenSeenOnce = () =>
  Cookie.get(AppConfig.cookies.teamsDrawerSeenOnce.name);

function readCookie(): { date: string | Date } {
  const drawerBeenSeenOnce = teamsDrawerBeenSeenOnce();

  if (!drawerBeenSeenOnce) {
    return { date: new Date() };
  }

  const hasSeenTeamsDrawerOnce = drawerBeenSeenOnce.split(',');
  const [date] = hasSeenTeamsDrawerOnce;

  return { date };
}

export function checkCookieData(): {
  numberOfDaysSinceLastSeen: number;
} {
  const previousData = readCookie();

  const numberOfDaysSinceLastSeen = Helper.getDaysBetweenDates(
    previousData.date,
    new Date()
  );

  return {
    numberOfDaysSinceLastSeen,
  };
}

export const checkDrawerCookie = (): string | boolean =>
  teamsDrawerDismissedForever() ||
  (teamsDrawerBeenSeenOnce() &&
    checkCookieData().numberOfDaysSinceLastSeen <= 3);

export const willDrawerBeVisible = () =>
  drawerDisplayCondition && !checkDrawerCookie();
